import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/auth";
import { ContentProvider } from "@/content";
import PublicSite from "@/pages/PublicSite";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import DevisPublic from "@/pages/DevisPublic";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicSite />} />
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/devis/:token" element={<DevisPublic />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
